export default __webpack_public_path__ + "static/media/logo-color.e949037b.png";